<template>
    <section id="contact-us" class="contact">
        <div data-aos="flip-up" data-aos-duration="1000" class="section-title">
            <h2>ارتباط با ما</h2>
            <p>از طریق مسیرهای زیر میتوانید با ما ارتباط برقرا نمایید</p>
        </div>
        <div class="col-12">
            <div data-aos="fade-right"
                 data-aos-duration="1000"
                 class="col-lg-4 float-dynamic">
                <div class="col-2 pt-3 float-dynamic">
                    <b-icon scale="2" icon="geo-alt"></b-icon>
                </div>
                <div class="col-10 float-dynamic">
                    <h4 class="mt-3">آدرس</h4>
                    <p>{{  siteSetting.address }}</p>
                </div>
            </div>
            <div data-aos="fade-up"
                 data-aos-duration="1000"
                 class="col-lg-4 float-dynamic">
                <div class="col-2 pt-3 float-dynamic">
                    <b-icon scale="2" icon="envelope-fill"></b-icon>
                </div>
                <div class="col-10 float-dynamic">
                    <h4 class="mt-3">ایمیل</h4>
                    <p>{{  siteSetting.email }}</p>
                </div>
            </div>
            <div data-aos="fade-left"
                 data-aos-duration="1000"
                 class="col-lg-4 float-dynamic">
                <div class="col-2 pt-3 float-dynamic">
                    <b-icon scale="2" icon="telephone-fill"></b-icon>
                </div>
                <div class="col-10 float-dynamic">
                    <h4 class="mt-3">تلفن</h4>
                    <p class="d-inline-block" style="direction:ltr;">{{  siteSetting.tel }}</p>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    export default {

        props: {
            siteSetting: {
                type: Object
            }
        },

        data()
        {
            return {};
        }
    };
</script>
<style scoped>
    .contact {
        background: #fff;
    }

        .contact .info-wrap {
            padding: 30px;
            background: #fff;
            border-radius: 4px;
        }

        .contact .info svg {
            color: #3498db;
            float: right;
            background: #eaf4fb;
            align-items: center;
            border-radius: 50px;
            transition: all 0.3s ease-in-out;
        }

        .contact .info h4 {
            padding: 0 0 0 60px;
            font-size: 22px;
            font-weight: 600;
            margin-bottom: 5px;
            color: #384046;
        }

        .contact .info p {
            padding: 0 0 0 60px;
            margin-bottom: 0;
            font-size: 14px;
            color: #65747f;
        }

        .contact .info:hover i {
            background: #3498db;
            color: #fff;
        }
</style>
